import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
<link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet"></link>
// import * as serviceWorker from './serviceWorker';
// import reportWebVitals from './reportWebVitals';

// ReactDOM.hydrate(
ReactDOM.hydrate(
  // <React.StrictMode>
    <App />,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// serviceWorker.unregister();
// serviceWorker.unregister();